/* eslint-disable react/no-deprecated */
import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { fetchWalletBalance } from "../../../services/VoipServices";
import CallHistoryContainer from "./CallHistoryContainer";
import { fetchContacts } from "../../../state/actions/contacts";
import { makeCall } from "../../../state/actions/phone";

const prefixText = (color = "#808080") => ({
	alignItems: "center",
	display: "flex",
	":before": {
		content: '"Filter by:"',
		color: color,
		display: "block",
		marginRight: 8,
	},
});

const colourStyles = {
	control: (styles) => ({
		...styles,
		border: "1px solid rgb(232, 233, 238)",
		boxShadow: "none",
		backgroundColor: "white",
		color: "#808080",
	}),
	option: (styles, { data, isDisabled, isFocused, isSelected }) => {
		return {
			...styles,
			color: isSelected ? "#fff" : "#808080",
		};
	},
	input: (styles) => ({ ...styles, ...prefixText() }),
	placeholder: (styles) => ({
		...styles,
		...prefixText(),
	}),
	singleValue: (styles, { isSelected }) => ({
		...styles,
		color: isSelected ? "#808080" : "#808080",
		...prefixText(),
	}),
};

const NewCallContactsContainer = ({
	onCloseDialler,
	createConversation,
	userId,
	noBalance,
	showDialPad,
}) => {
	const isAnonymousUser = useSelector((state) => state.user.isAnonymousUser);
	const selectedDomain = useSelector((state) => state.domain.selectedDomain);
	const balance = useSelector((state) => state.user.balance);
	const accepted = useSelector((state) => state.contacts.accepted);
	const localContacts = useSelector((state) => state.contacts.localContacts);
    const vessels = useSelector((state) => state.contacts.vessels);
	const user = useSelector((state) => state.user);
	const emailAddress = useSelector((state) => state.user.emailAddress);
	const bots = useSelector((state) => state.user.botSubscriptions);
	const geoData = useSelector((state) => state.user.geoData);
	
	const [userBalance, setUserBalance] = useState(0);
	const [display, setDisplay] = useState("recents");
	const [selectedOption, setSelectedOption] = useState("");
	const [allContacts, setAllContacts] = useState([]);
	const [contacts, setContacts] = useState([]);
	const [searchText, setSearchText] = useState(null);
	const [openDialPad, setOpenDialPad] = useState(false);
	
	const [allOptions] = useState([
		{ label: "All contacts", value: "allContacts" },
		{ label: "People", value: "people" },
		{ label: "Vessels", value: "vessels" },
	]);

	// ComponentDidMount equivalent
	useEffect(() => {
		if (!isAnonymousUser) {
			fetchContacts({
				selectedDomain: selectedDomain,
			});
			getBalance();
		}
	}, []); // Empty dependency array for componentDidMount

	// ComponentDidUpdate equivalent
	useEffect(() => {
		let contactsList = [
			...accepted,
			...localContacts,
			...vessels,
		];
		setAllContacts([...contactsList]);
		searchContacts(searchText, contactsList);
	}, [accepted, localContacts, vessels]); // Dependencies that trigger the effect

	const doSearch = (searchText) => {
		let contactsList = [
			...accepted,
			...localContacts,
			...vessels,
		];
		searchContacts(searchText, contactsList);
	};

	const getBalance = async () => {
		let walletBalance = await fetchWalletBalance();
		setUserBalance(walletBalance);
	};

	const searchContacts = (searchText, contactsList) => {
		if (!searchText || !searchText.length) {
			setContacts(contactsList);
			setSelectedOption("");
			setSearchText(null);
			return;
		}
		let filtered = contactsList.filter(function (contact) {
			let field1 = contact.name ? contact.name : contact.userName,
				field2 = contact.emailAddress;
			let select = false;
			try {
				select =
					(field1 &&
						field1.toLowerCase().search(searchText.toLowerCase()) !== -1) ||
					(field2 &&
						field2.toLowerCase().search(searchText.toLowerCase()) !== -1);
			} catch (e) {}
			return select;
		});
		setContacts(filtered);
		setSearchText(searchText);
	};

	const getCredits = () => {
		let botsArray = [...bots];
		let digitalWallet = botsArray.find((obj) => obj.botId === "DigitalWallet");
		// console.log("Top-up =============", digitalWallet);
		if (digitalWallet) {
			onCloseDialler();
			createConversation(digitalWallet, userId);
		} else {
			alert("You need to install the Digital Wallet bot");
		}
	};

	const makePhoneCall = async (phone, callMode) => {
		if (callMode === "sat") {
			makeCall("sat", emailAddress, phone, phone, null, "on-call");
		} else {
			makeCall("phone", emailAddress, phone, phone, null, "on-call");
		}
	};

	const handleChangeFilter = (selectedOption) => {
		setSelectedOption(selectedOption);
		let allContactsList = allContacts;
		let newContact = [];
		switch (selectedOption.value) {
			case "people":
				allContactsList.forEach((elem) => {
					if (!elem.type) {
						newContact.push(elem);
					}
				});
				break;
			case "vessels":
				allContactsList.forEach((elem) => {
					if (elem.type) {
						newContact.push(elem);
					}
				});
				break;
			default:
				newContact = [...allContactsList];
				break;
		}

		setContacts([...newContact]);
	};

	const showContacts = () => {
		setDisplay("contacts");
	};

	const showRecentCalls = () => {
		setDisplay("recents");
	};

	const showCreateConversation = () => setOpenDialPad(true);
	const closeCreateConversation = () => setOpenDialPad(false);

	return (
		<div>
			
			{/* <div className="credit-container row justify-content-between px-5">
				<div style={{ display: "flex", flexDirection: "column" }}>
					<span>Call to phone</span>
					<span>Current balance : $ {userBalance}</span>
				</div>

				<div>
					<div
						className="get-credit"
						style={{ cursor: "pointer" }}
						onClick={getCredits}
					>
						<a>
							<span>Top-up</span>
						</a>
					</div>
				</div>
			</div> */}

			{/* <div
				className="d-flex justify-content-between align-items-center"
				style={{
					height: "40px",
					backgroundColor: "#F4F4F4"
				}}
			>
				<a
					className="d-flex justify-content-center align-items-center"
					style={{
						color: display === "contacts" ? "#00A7D6" : "#4A4A4A",
						fontSize: "14px",
						width: "50%",
						height: "100%",
						borderRight: "1px solid #E9E9E9",
						borderBottom: display === "contacts" ? "2px solid #00A7D6" : "0px"
					}}
					onClick={showContacts}
				>
					FrontM Contacts
				</a>
				<a
					className="d-flex justify-content-center align-items-center"
					style={{
						color: display === "recents" ? "#00A7D6" : "#4A4A4A",
						fontSize: "14px",
						width: "50%",
						height: "100%",
						borderRight: "1px solid #E9E9E9",
						borderBottom: display === "recents" ? "2px solid #00A7D6" : "0px"
					}}
					onClick={showRecentCalls}
				>
					Recent Calls
				</a>
			</div> */}

			{/* {display === "contacts" && (
				<div className="px-5">
					<FormGroup check className="mt-3" style={{ paddingLeft: 0 }}>
						<Select
							placeholder={"All contacts"}
							value={selectedOption}
							options={allOptions}
							onChange={handleChangeFilter}
							styles={colourStyles}
						/>
					</FormGroup>
				</div>
			)} */}

			<div className="d-flex flex " style={{ marginTop: "13px" }}>
				{/* {display === "contacts" && (
				<ContactsListForCall
					contacts={contacts}
					searchText={searchText}
					height={"350px"}
					onCloseDialler={onCloseDialler}
				/>
				)} */}

				{/* {display === "recents" && ( */}
				<CallHistoryContainer
					height={"350px"}
					user={user.user}
					balance={balance}
					noBalance={() => noBalance()}
					emailAddress={emailAddress}
					closeCallHistory={onCloseDialler}
				/>
				{/* )} */}

				{/* <div className="btn-dialpad">
				<a
					onClick={showCreateConversation}
					className="btn btn-default d-inline-flex justify-content-center align-items-center"
				>
					<img loading="lazy" src="/img/tab-dialpad-icon@2x.png" width="10" alt="" />
					<span>Dialpad</span>
				</a>
				</div> */}
			</div>
			{/* 
			{openDialPad && (
				<ModalPopup
					onClose={closeCreateConversation}
					size="sm"
					noHeader
					className="dialler-modal"
				>
					<DiallerKeyPad
						makePhoneCall={makePhoneCall}
						onClose={closeCreateConversation}
					/>
				</ModalPopup>
			)} */}
		</div>
	);
};


const mapDataToProps = (state, props) => {
	return {
		user: state.user,
		isAnonymousUser: state.user.isAnonymousUser,
		balance: state.user.balance,
		accepted: state.contacts.accepted,
		localContacts: state.contacts.localContacts,
		vessels: state.contacts.vessels,
		userId: state.user.user.userId,
		emailAddress: state.user.user.emailAddress,
		bots: state.user.botSubscriptions,
		geoData: state.user.geoData,
	};
};

export default NewCallContactsContainer